import { LegalPage } from './LegalPage';

export function Terms() {
  return (
    <LegalPage title="Terms of Use" lastUpdated="2026-05-13">
      <div className="legal__draft-banner">
        DRAFT — Replace this template with reviewed legal copy before submitting MeetFlow to Microsoft AppSource. Page exists at /terms so the Teams app manifest resolves correctly.
      </div>

      <p>
        These Terms of Use ("Terms") govern your use of the MeetFlow application ("MeetFlow", the "Service") provided by Ananeos
        ("we", "us", "our"). By installing or using MeetFlow you agree to these Terms.
      </p>

      <h2>1. The Service</h2>
      <p>
        MeetFlow is a Microsoft Teams Tab application that helps teams run structured recurring meetings by capturing agendas,
        notes, and agreements, and by creating Microsoft Planner tasks for follow-ups. MeetFlow operates against your
        organization's Microsoft 365 tenant via Microsoft Graph.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You may use MeetFlow only if you have authority to install or use applications inside your organization's Microsoft 365
        tenant, or with the permission of someone who does.
      </p>

      <h2>3. Acceptable use</h2>
      <ul>
        <li>You will not attempt to reverse-engineer, decompile, or interfere with MeetFlow.</li>
        <li>You will not use MeetFlow to store unlawful content or content you do not have the right to store.</li>
        <li>You will not attempt to access another tenant's data or another user's account.</li>
      </ul>

      <h2>4. Your data</h2>
      <p>
        Meeting data created via MeetFlow is stored in your own Microsoft 365 tenant. You retain full ownership and control of
        that data. See our <a href="/privacy">Privacy Policy</a> for details.
      </p>

      <h2>5. Microsoft 365 dependency</h2>
      <p>
        MeetFlow depends on Microsoft 365 services (Microsoft Teams, SharePoint, Planner, Graph API). Availability or
        functionality of MeetFlow may be affected by changes to these services that are outside our control.
      </p>

      <h2>6. Pricing</h2>
      <p>
        MeetFlow is offered free of charge during the early-access period. Pricing for the general release will be communicated
        in advance, and continued use after a paid plan goes into effect requires agreement to the applicable pricing terms.
      </p>

      <h2>7. Warranty disclaimer</h2>
      <p>
        MeetFlow is provided "as is" without warranty of any kind, express or implied, including but not limited to warranties
        of merchantability, fitness for a particular purpose, and non-infringement.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Ananeos shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages, or any loss of profits, revenues, data, or goodwill arising from your use of
        MeetFlow.
      </p>

      <h2>9. Termination</h2>
      <p>
        You may uninstall MeetFlow at any time from within Microsoft Teams. We may suspend or discontinue the Service for any
        reason, including but not limited to violations of these Terms.
      </p>

      <h2>10. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. The "Last updated" date at the top reflects the most recent revision.
        Continued use of MeetFlow after a change constitutes acceptance of the updated Terms.
      </p>

      <h2>11. Governing law</h2>
      <p>
        These Terms are governed by the laws of the jurisdiction in which Ananeos is established, without regard to its conflict
        of law provisions.
      </p>

      <h2>12. Contact</h2>
      <p>
        Ananeos<br />
        <a href="mailto:legal@ananeos.com">legal@ananeos.com</a>
      </p>
    </LegalPage>
  );
}
